<template>
  <SignupWizard />
</template>

<script setup lang="ts">
import { useAuthLayoutMedia } from '~/composables/useAuthLayoutMedia';
import { type AuthErrorCode, getAuthErrorCodes } from '~/constants/errorCodes';
import SignupWizard from '~/pages/signup/_components/SignupWizard.vue';
import { useToastStore } from '~/stores/toast';

const router = useRouter();

definePageMeta({
  layout: 'auth',
});

useAuthLayoutMedia().showAnimation();

const toastStore = useToastStore();

onMounted(() => {
  const err_code = router.currentRoute.value.query.err_code as unknown as AuthErrorCode;
  if (err_code) {
    toastStore.error(getAuthErrorCodes(err_code).message);
  }
});
</script>